import React, { useCallback, useRef } from 'react'
import PropTypes from 'prop-types'
import { Link, graphql, useStaticQuery } from 'gatsby'

import { resolveWordPressPathForGatsby } from '../../../utils'
import './Menu.css'

const menuStaticQuery = graphql`
  query MenuWordpressPages {
    allWordpressPage(
      filter: { status: { eq: "publish" } }
      sort: { fields: [title], order: ASC }
    ) {
      edges {
        node {
          id
          title
          path
        }
      }
    }
  }
`

const homeItem = { id: 'menu-home', title: 'Accueil', url: '/' }

const Menu = ({ handleSlidePause, handleSlidePlay }) => {
  const data = useStaticQuery(menuStaticQuery)
  const menuRef = useRef(null)

  const wpLinks = (data.allWordpressPage && data.allWordpressPage.edges ? data.allWordpressPage.edges : []).map(
    ({ node }) => ({
      id: node.id,
      title: node.title || '',
      url: resolveWordPressPathForGatsby(node.path),
    })
  )

  const wpLinksWithoutHomeDup = wpLinks.filter(item => item.url !== '/')
  const menuLinks = [homeItem, ...wpLinksWithoutHomeDup]

  const openMenu = useCallback(() => {
    const container = menuRef.current
    if (!container) {
      return
    }

    const button = container.querySelector('.menu__trigger')
    const wrapper = container.querySelector('.menu__wrapper')

    button.setAttribute('aria-expanded', 'true')
    wrapper.setAttribute('aria-hidden', 'false')

    if (typeof handleSlidePause === 'function') {
      handleSlidePause()
    }
  }, [handleSlidePause])

  const closeMenu = useCallback(() => {
    const container = menuRef.current
    if (!container) {
      return
    }

    const button = container.querySelector('.menu__trigger')
    const wrapper = container.querySelector('.menu__wrapper')

    button.setAttribute('aria-expanded', 'false')
    wrapper.setAttribute('aria-hidden', 'true')

    if (typeof handleSlidePlay === 'function') {
      handleSlidePlay()
    }
  }, [handleSlidePlay])

  const toggleMenu = useCallback(() => {
    const container = menuRef.current
    if (!container) {
      return
    }

    const button = container.querySelector('.menu__trigger')
    const isOpen = button.getAttribute('aria-expanded') === 'true'

    if (isOpen) {
      closeMenu()
    } else {
      openMenu()
    }
  }, [closeMenu, openMenu])

  return (
    <div className="menu" ref={menuRef}>
      <button
        aria-expanded="false"
        aria-label="Afficher le menu"
        className="menu__trigger"
        onClick={toggleMenu}
        type="button"
      >
        <span />
      </button>
      <div className="menu__wrapper" aria-hidden="true">
        <div className="menu__holder">
          <ul>
            {menuLinks.map(item => (
              <li key={item.id}>
                <Link to={item.url} onClick={closeMenu}>
                  {item.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

Menu.propTypes = {
  handleSlidePause: PropTypes.func,
  handleSlidePlay: PropTypes.func,
}

export default Menu
